import { Popup } from '@repo/design-system-kit/components/popup/popup';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { NoPairedDeviceSvg } from '../../../svgs/no-paired-device';
import { useFaqService } from '../../../utils/faq-composer';
import styles from './sca.module.css';

interface NoPairedDeviceProps {
  onClose?: () => void;
}
export function NoPairedDevice({ onClose }: NoPairedDeviceProps): React.ReactNode {
  const faqService = useFaqService();
  const [isOpen, setIsOpen] = useState(true);
  const { formatMessage } = useIntl();
  const handleClose = (): void => {
    onClose?.();
    setIsOpen(false);
  };

  return (
    <Popup.Root
      aria-label={formatMessage({ id: 'sca.no-paired-device.title' })}
      data-testid="sca-no-paired-device"
      isOpen={isOpen}
      role="dialog"
    >
      <Popup.CloseButton onPress={handleClose} />
      <Popup.Header>
        <figure className={styles.illustrationWrap}>
          <NoPairedDeviceSvg />
        </figure>
        <Popup.Title>
          <FormattedMessage id="sca.no-paired-device.title" />
        </Popup.Title>
        <Popup.Subtitle>
          <FormattedMessage id="sca.no-paired-device.subtitle" />
        </Popup.Subtitle>
      </Popup.Header>
      <Popup.Body>
        <a
          className={styles.faqLink}
          href={faqService.getLocalizedArticle('what_is_sca')}
          rel="noopener noreferrer"
          target="_blank"
        >
          <FormattedMessage id="sca.no-paired-device.info" />
        </a>
      </Popup.Body>
    </Popup.Root>
  );
}
